import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

const Search = ({ value, onChange }) => {
  return <input value={ value } onChange={ (e) => onChange(e.target.value) } placeholder="Search event" className="search" />
}

export default class Sidebar extends React.Component {

  static propTypes = {
    allMarkdownRemark: PropTypes.object,
    pageContext: PropTypes.object,
    searchMode: PropTypes.bool,
    search: PropTypes.string,
    onSearch: PropTypes.func,
    mobile: PropTypes.bool,
    opened: PropTypes.bool
  }

  render() {
    const { searchMode, search, onSearch, allMarkdownRemark, pageContext, mobile, opened } = this.props
    return (
      <aside className={ `glossary-sidebar ${ mobile ? 'mobile' : '' } ${ opened ? 'showed' : '' }` }>
        { mobile && <Search value={ search } onChange={ (searchString) => { onSearch(searchString) } } /> }
        {
          !searchMode && (<ul>
            { _.filter(allMarkdownRemark.edges, e => !e.node.frontmatter.parent).map(({ node }) => (
              <li key={ node.fields.slug }><a className={ _.isEqual(node.fields.slug, pageContext.slug) ? 'active' : '' } href={ node.fields.slug }>{ node.frontmatter.title }</a>
                { _.filter(allMarkdownRemark.edges, e => e.node.frontmatter.parent === node.fields.key).length > 0 &&
                  <ul>
                    { _.filter(allMarkdownRemark.edges, e => e.node.frontmatter.parent === node.fields.key).map(({ node }) => (
                      <li key={ node.fields.slug }><a className={ _.isEqual(node.fields.slug, pageContext.slug) ? 'active' : '' } href={ node.fields.slug }>{ node.frontmatter.title }</a>
                        {_.filter(allMarkdownRemark.edges, e => e.node.frontmatter.parent === node.fields.key).length > 0 && <ul>
                          {_.filter(allMarkdownRemark.edges, e => e.node.frontmatter.parent === node.fields.key).map(({ node }) => (
                            <li key={node.fields.slug}><a className={_.isEqual(node.fields.slug, pageContext.slug) ? 'active' : ''} href={node.fields.slug}>{node.frontmatter.title}</a></li> ) ) }
                        </ul> }
                      </li>
                    ) ) }
                  </ul>
                }
              </li>
            ))}
          </ul>)
        }
        {
          searchMode && (<ul>
            { _.filter(allMarkdownRemark.edges, e => e.node.frontmatter.type === 'event').map(({ node }) => {
              const flatNodes = [{node}]
              return (
                <React.Fragment>
                  { flatNodes.map(({ node }) => {
                    if (!node.frontmatter.title.toLowerCase().includes(search.toLowerCase())) return
                    return <li key={ node.fields.slug }><a href={ node.fields.slug }>{ node.frontmatter.title }</a></li>
                  })}
                </React.Fragment>
              )})}
          </ul>)
        }
      </aside>
    )
  }
}
